import React from 'react';
import './MockCardFields.css';

// Stand-in for the Stripe Payment Element until a real publishable key lands
// (REACT_APP_STRIPE_PUBLISHABLE_KEY is still the {{STRIPE_PUBLISHABLE_KEY}} placeholder).
// Purely cosmetic — Checkout.jsx's mock-mode submit path doesn't read these values.
export default function MockCardFields() {
  return (
    <div className="tp-mock-card">
      <p className="label-m tp-mock-card__badge">Test mode — no real charge</p>
      <input className="input tp-mock-card__field" placeholder="Card number" defaultValue="4242 4242 4242 4242" readOnly />
      <div className="tp-mock-card__row">
        <input className="input tp-mock-card__field" placeholder="MM / YY" defaultValue="12 / 34" readOnly />
        <input className="input tp-mock-card__field" placeholder="CVC" defaultValue="123" readOnly />
      </div>
    </div>
  );
}
